import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {ListContractDigitizationComponent} from './list-contract/list-contract.component';
import {AddContractDigitizationComponent} from './add-contract/add-contract.component';


const routes: Routes = [
  {
    path: '',
    component: ListContractDigitizationComponent
  },
  {
    path: 'create',
    component: AddContractDigitizationComponent,
    data: {
      breadcrumb: ['breadcrumbs.document_digitization_create'],
    }
  },
  {
    path: ':contractID/update',
    component: AddContractDigitizationComponent,
    data: {
      breadcrumb: ['breadcrumbs.document_digitization_update'],
    }
  },
  {
    path: ':contractID/view',
    component: AddContractDigitizationComponent,
    data: {
      breadcrumb: ['breadcrumbs.document_digitization_view'],
    }
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ContractDigitizationRoutingModule { }
